import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <div className="hero d-flex align-items-center justify-content-center text-center">
      <div className="hero-logo">
      </div>
    </div>
  );
}

export default Hero;
